import SelectionIntention from 'wixPaste/SelectionIntention';
import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';

function removeEmptyElementInPath(path, editor, selectionIntention) {
    _.forEach(path.elements, function (element) {
        if (!editor.editable().contains(element)) {
            return;
        }
        if (element.contains(selectionIntention.container) || element.equals(selectionIntention.container)) {
            return false;//eslint-disable-line consistent-return
        }
        if (elementUtils.isElementTextEmpty(element)) {
            element.remove();
            return;
        }
        return false;//eslint-disable-line consistent-return
    });
}

function shouldSetCursorAtStartBlock(editor) {
    var range = selectionUtils.getSelectedRange(editor);
    return rangeUtils.isEndBlockFullyInRange(range) || !rangeUtils.isStarBlockFullyInRange(range);
}

function getSelectionIntentionForStartBlock(editor, range) {
    if (range.startContainer.type === CKEDITOR.NODE_TEXT && range.startOffset === 0) {
        return new SelectionIntention(editor, range.startContainer.getParent(), range.startContainer.getIndex());
    }
    return new SelectionIntention(editor, range.startContainer, range.startOffset);
}

function getSelectionIntentionForEndBlock(editor, range) {
    if (range.endContainer.type === CKEDITOR.NODE_TEXT) {
        return new SelectionIntention(editor, range.endContainer.getParent(), 0);
    }
    return new SelectionIntention(editor, range.endContainer, 0);
}

function getSelectionIntentionMultiBlock(editor) {
    var range = selectionUtils.getSelectedRange(editor);
    if (shouldSetCursorAtStartBlock(editor)) {
        return getSelectionIntentionForStartBlock(editor, range);
    }
    return getSelectionIntentionForEndBlock(editor, range);
}

function deleteContentsMultiBlock(editor) {
    var range = selectionUtils.getSelectedRange(editor),
        selectionIntention = getSelectionIntentionMultiBlock(editor);
    var pathToRemoveEmptyElements = shouldSetCursorAtStartBlock(editor) ? range.endPath() : range.startPath();
    range.deleteContents(false);
    removeEmptyElementInPath(pathToRemoveEmptyElements, editor, selectionIntention);
    return selectionIntention;
}

function deleteContentsSingleBlock(editor) {
    var range = selectionUtils.getSelectedRange(editor),
        endPath = range.endPath(),
        selectionIntention = getSelectionIntentionForStartBlock(editor, range);
    range.deleteContents(true);
    removeEmptyElementInPath(endPath, editor, selectionIntention);
    return selectionIntention;
}

function deleteSelectionContents(editor) {
    selectionUtils.fixSelectionOnBodyIfNeeded(editor);

    if (!selectionUtils.isMultipleBlockSelection(editor, true)) {
        return deleteContentsSingleBlock(editor);
    }
    return deleteContentsMultiBlock(editor);
}

export default {
    deleteSelectionContents: deleteSelectionContents
};
